module.exports = __webpack_public_path__ + "static/img/szafa_15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_15.svg
// module id = Ca/F
// module chunks = 0